import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Insurance from "@/shared/model/Insurance";
import InsuranceHeadComponent from "@/modules/Insurance/components/InsuranceComponent.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogSkeleton from "@/shared/ui/SogSkeleton.vue";

interface Props {
  insurance?: Insurance
  skeletonVisible?: boolean
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'InsuranceCardComponent',
  props: {
    insurance: { default: undefined },
    skeletonVisible: { type: Boolean, default: false }
  },
  setup(__props: any) {



const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogCard, null, {
    default: _withCtx(() => [
      _createVNode(SogCardTitle, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.insurance?.insuranceNumber), 1)
        ]),
        _: 1
      }),
      _renderSlot(_ctx.$slots, "default"),
      _withDirectives(_createVNode(SogCardContent, null, {
        default: _withCtx(() => [
          _createVNode(InsuranceHeadComponent, { insurance: __props.insurance }, null, 8, ["insurance"])
        ]),
        _: 1
      }, 512), [
        [_vShow, !__props.skeletonVisible]
      ]),
      _createVNode(SogCardContent, null, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(SogSkeleton, null, null, 512), [
            [_vShow, __props.skeletonVisible]
          ])
        ]),
        _: 1
      })
    ]),
    _: 3
  }))
}
}

})